export { validateNoOverlaps };

type DateRange = {
  termLabel: string;
  startDate: string;
  endDate: string;
};

type Overlap = {
  termLabel: string;
  overlapsWithTermLabel: string;
};

// Returns the first overlapping pair found, or null if none overlap. Mirrors the server-side check
// in api/src/util/termDates.ts so the UI can show an inline warning before attempting to save.
function validateNoOverlaps(ranges: DateRange[]): Overlap | null {
  const sorted = [ ...ranges ].sort((a, b) => new Date(a.startDate).getTime() - new Date(b.startDate).getTime());

  for (let i = 1; i < sorted.length; i++) {
    const previous = sorted[i - 1];
    const current = sorted[i];

    if (new Date(current.startDate).getTime() <= new Date(previous.endDate).getTime()) {
      return { termLabel: current.termLabel, overlapsWithTermLabel: previous.termLabel };
    }
  }

  return null;
}
